import { NpoPlayerEvent } from '../../types/events';
export const handleLiveStreamControls = (playerContext) => {
    const liveStreamHandleTimeChangedCallback = () => updateForwardButtonState(playerContext.player);
    const { player, npoplayer } = playerContext;
    player.on(NpoPlayerEvent.TimeChanged, liveStreamHandleTimeChangedCallback);
    npoplayer.eventListeners = {
        liveStreamHandleTimeChangedCallback
    };
};
export function updateForwardButtonState(player) {
    const timeShift = player?.getTimeShift();
    const forwardButtons = player?.getContainer().querySelectorAll('.bmpui-ui-forwardbutton');
    player.off(NpoPlayerEvent.TimeChanged, () => {
        updateForwardButtonState(player);
    });
    if (forwardButtons && timeShift !== undefined) {
        toggleForwardButtons(forwardButtons, timeShift);
    }
}
export function toggleForwardButtons(forwardButtons, timeShift) {
    for (const forwardButton of forwardButtons) {
        if (timeShift > -10) {
            disableForwardButton(forwardButton);
        }
        else {
            enableForwardButton(forwardButton);
        }
    }
}
export function disableForwardButton(button) {
    button.setAttribute('disabled', 'true');
}
export function enableForwardButton(button) {
    button.removeAttribute('disabled');
}
